import { createContext, useContext } from 'react';

export type ThemeMode = 'light' | 'dark';

export const PRIMARY_COLOR = '#1F4E79';

export interface ThemeState {
  mode: ThemeMode;
  toggle: () => void;
  /** Switch to `mode` unless the user has picked a theme themselves (the dispatcher
   * desk is dark by default, TZ 15.1, but a choice made with the switch wins). */
  prefer: (mode: ThemeMode) => void;
}

export const ThemeContext = createContext<ThemeState | null>(null);

export function useThemeMode(): ThemeState {
  const state = useContext(ThemeContext);
  if (!state) throw new Error('useThemeMode must be used inside ThemeProvider');
  return state;
}
